// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Rwanda from '../_raw/flag/icon_flag_rwanda.png';

export default () => <img src={Rwanda} alt="Rwanda" />;
